/**
 * Optional marketing/analytics IDs from environment variables.
 *
 * GTM container IDs and Meta Pixel IDs are not secret API keys — they are
 * public identifiers that appear in every visitor's browser. They belong in
 * .env so you can enable/disable them per environment without editing code
 * or committing values to git.
 *
 * Never put Meta access tokens, GTM API keys, or other server secrets here.
 */

const GTM_ID_PATTERN = /^GTM-[A-Z0-9]+$/i;
const META_PIXEL_ID_PATTERN = /^\d{5,20}$/;

const sanitizeId = (raw, pattern) => {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  if (!trimmed || !pattern.test(trimmed)) return null;
  return trimmed;
};

const gtmContainerId = sanitizeId(
  process.env.REACT_APP_GTM_CONTAINER_ID,
  GTM_ID_PATTERN,
);

const metaPixelId = sanitizeId(
  process.env.REACT_APP_META_PIXEL_ID,
  META_PIXEL_ID_PATTERN,
);

export const analyticsConfig = {
  gtmContainerId,
  metaPixelId,
  isGtmEnabled: Boolean(gtmContainerId),
  isMetaPixelEnabled: Boolean(metaPixelId),
};
